/**
 * Formats the canonical HGVS display string for a variant:
 * NM_004817.4(TJP2):c.2492C>T(p.(Thr831Met))
 */
export const formatVariantHgvs = (v: {
  transcript_external_id?: string | null;
  gene_symbol?: string | null;
  cdna?: string | null;
  protein_change?: string | null;
  hgvs_genomic?: string | null;
}): string => {
  if (v.transcript_external_id || v.cdna) {
    return `${v.transcript_external_id ?? ''}(${v.gene_symbol ?? ''}):${v.cdna ?? ''}(${v.protein_change ?? ''})`;
  }
  return v.hgvs_genomic || 'N/A';
};
